import React from "react";
import { Droppable } from "react-beautiful-dnd";
import OrderCard from "./OrderCard";

export default function OrdersColumn({
  droppableId,
  statusLabel,
  orders,
  expandedOrderId,
  toggleOrder,
  footer,
  setIsAnyModalActive, 
}) {
  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <div
          className={`orders-column ${statusLabel.replace(" ", "-")}`}
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100%",
          }}
        >
          <h2
            className={`orders-column-heading ${statusLabel.replace(" ", "-")}`}
          >
            {statusLabel.toUpperCase()} ({orders.length})
          </h2>

          <div className="orders-list" style={{ flexGrow: 1 }}>
            {orders.map((order, index) => (
              <OrderCard
                key={order.id}
                order={order}
                index={index}
                expanded={expandedOrderId === order.id}
                onToggle={() => toggleOrder(order.id)}
                setIsAnyModalActive={setIsAnyModalActive} 
              />
            ))}
            {provided.placeholder}
          </div>

          {/* Render footer only if there are orders and footer exists */}
          {orders.length > 0 && footer && (
            <div className="orders-column-footer" style={{ marginTop: "auto" }}>
              {footer}
            </div>
          )}
        </div>
      )}
    </Droppable>
  );
}
